export const contactData = [[
{
  id: 0,
  name: 'Scott Coulson',
  position: 'Executive Secretary',
  address: '',
  school: '',
  email: 'uilmusicregion20@gmail.com',
  // department: 'BAND'
},
{
  id: 1,
  name: 'Paul Doucet',
  position: 'President',
  address: '',
  school: 'Duncanville ISD',
  email: 'Pdoucet@duncanvilleisd.org',
  // department: 'BAND'
},
{
  id: 2,
  name: 'Arkette Baptiste',
  position: 'Vice President',
  address: '',
  school: 'Dallas ISD',
  email: 'abaptiste@dallasisd.org',
  // department: 'BAND'
},
{
  id: 3,
  name: 'Scott Anderson',
  position: 'Secretary',
  address: '',
  school: 'Dallas ISD',
  email: 'scanderson@dallasisd.org',
  // department: 'BAND'
},
{
  id: 4,
  name: 'Paula Tagalos',
  position: 'High School Band Chair',
  address: '',
  school: 'Duncanville High School',
  email: 'TMEARegion20Band@gmail.com',
  department: 'BAND'
},
{
  id: 5,
  name: 'Megan Czerwieski',
  position: 'Middle School Band Chair',
  address: '',
  school: 'Red Oak ISD',
  email: 'megan.czerwieski@redoakisd.org',
  department: 'BAND'
},
{
  id: 6,
  name: 'Natalie Walke',
  position: 'High School Choir Chair',
  address: '',
  school: 'Highland Park ISD',
  email: 'walkern@hpisd.org',
  department: 'CHOIR'
},
{
  id: 7,
  name: 'Bethany Ring',
  position: 'Middle School Choir Chair',
  address: '',
  school: 'Dallas ISD',
  email: 'bring@dallasisd.org',
  department: 'CHOIR'
},
{
  id: 8,
  name: 'Jillian Attan',
  position: 'High School Orchestra Chair',
  address: '',
  school: 'Irving ISD',
  email: 'jattan@irvingisd.net',
  department: 'ORCHESTRA'
},
{
  id: 9,
  name: 'Rachel Woods',
  position: 'Middle School Orchestra Chair',
  address: '',
  school: 'Dallas ISD',
  email: 'racwoods@dallasisd.org',
  department: 'ORCHESTRA'
},
{
  id: 10,
  name: 'Nadia Eimandoust',
  position: 'Mariachi Coordinator',
  address: '',
  school: 'Irving ISD',
  email: 'neimandoust@irvingisd.net',
  department: 'ORCHESTRA'
},
], 
// executive committee 
[
  {
    id: 1,
    name: 'Tabitha Branum',
    position: 'Chairman',
    address: '',
    school: 'Richardson ISD',
    email: 'Tabitha.Branum@risd.org',
    department: '',
    schoolPosition: 'Superintendent of Schools',
    phone: '469-593-0000',
  },
  {
    id: 2,
    name: 'Greg Bradley',
    position: '',
    address: '',
    school: 'Ennis ISD',
    email: 'greg.bradley@ennis.k12.tx.us',
    department: '',
    schoolPosition: 'Superintendent of Schools',
    phone: '972-872-7000',
  },
  {
    id: 3,
    name: 'Winnifred Goodman',
    position: '',
    address: '',
    school: 'Duncanville ISD',
    email: 'wgoodman@duncanvilleisd.org',
    department: '',
    schoolPosition: 'Chief of Schools- Elementary',
    phone: '972-708-2000',
  },
  {
    id: 4,
    name: 'Gayla Lawrence',
    position: '',
    address: '',
    school: 'Irving ISD',
    email: 'glawrence@irvingisd.net',
    department: '',
    schoolPosition: 'Assistant Director of Visual Arts',
    phone: '972-600-5088',
  },
  {
    id: 5,
    name: 'Hector Madrigal',
    position: '',
    address: '',
    school: 'Ferris ISD',
    email: 'hmadrigal@ferrisisd.org',
    department: '',
    schoolPosition: 'Superintendent of Schools',
    phone: '972-544-3858',
  },
  {
    id: 7,
    name: 'Rebecca McCutchen',
    position: '',
    address: '',
    school: 'Waxahachie ISD',
    email: 'rmccutchen@wisd.org',
    department: '',
    schoolPosition: 'Superintendent of Schools',
    phone: '972-923-4631',
  },
  {
    id: 8,
    name: 'Rametria Smith',
    position: '',
    address: '',
    school: 'Dallas ISD',
    email: 'ramsmith@dallasisd.org',
    department: '',
    schoolPosition: 'Director of Secondary Programs',
    phone: '214-932-5092',
  },
]]


//  – Chairman
// Superintendent of Schools
// Waxahachie ISD
// 411 N. Gibson Waxahachie, Texas 75165
// jhollingsworth@wisd.org
// 972-923-4631


// WEBPACK FOOTER //
// ./src/Components/Contacts/contact-data.js